import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PlatformAuthShell from "../../Clinic/Auth/PlatformAuthShell";
import AuthField from "../../Clinic/Auth/AuthField";
import Button from "../../ui/Button";
import { clearErr, fetchOwnerAuth } from "../../../store/authSlice";
import { isOwner } from "../../../utils/roles";
import a from "../../Clinic/Auth/auth.module.css";

function safeNextPath(next) {
  const value = String(next || "").trim();
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  return value;
}

function readNextPath(searchParams) {
  const direct = safeNextPath(searchParams.get("next"));
  if (direct) return direct;
  const raw = String(searchParams.toString() || "");
  const marker = "next=";
  const idx = raw.indexOf(marker);
  if (idx === -1) return null;
  const tail = raw.slice(idx + marker.length);
  try {
    return safeNextPath(decodeURIComponent(tail));
  } catch {
    return safeNextPath(tail);
  }
}

export default function OwnerLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = readNextPath(searchParams);
  const { isAuth, role, load, err, isPlatformAdmin } = useSelector(
    (state) => state.auth,
  );
  const [email, setEmail] = useState(() => searchParams.get("email") || "");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const fromQuery = searchParams.get("email");
    if (fromQuery) setEmail(fromQuery);
  }, [searchParams]);

  useEffect(() => {
    if (!isAuth || load) return;
    if (isPlatformAdmin) {
      navigate("/admin", { replace: true });
      return;
    }
    if (isOwner(role) && !isPlatformAdmin) {
      navigate(nextPath || "/account", { replace: true });
    }
  }, [isAuth, role, isPlatformAdmin, navigate, nextPath, load]);

  useEffect(() => {
    if (err) {
      const t = setTimeout(() => dispatch(clearErr()), 5000);
      return () => clearTimeout(t);
    }
  }, [err, dispatch]);

  const errorText =
    typeof err === "string" ? err : err?.message || err?.error || null;

  const submit = (e) => {
    e.preventDefault();
    if (load) return;
    const login = email.trim();
    if (!login || !password) return;
    dispatch(fetchOwnerAuth({ login, password }));
  };

  return (
    <PlatformAuthShell
      backTo="/"
      backLabel="На главную"
      title="Кабинет владельца"
      subtitle="Управляйте клубами и подписками"
    >
      <form onSubmit={submit}>
        {errorText ? <div className={a.errorBox}>{errorText}</div> : null}
        <AuthField
          label="Email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <AuthField
          label="Пароль"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" block size="lg" disabled={load}>
          {load ? "Вход…" : "Войти"}
        </Button>
      </form>
      <p className={a.footerLinks} style={{ marginTop: 16, textAlign: "center" }}>
        Нет клуба?{" "}
        <Link to="/register-clinic">Зарегистрировать секцию</Link>
      </p>
    </PlatformAuthShell>
  );
}
